import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, Row,Col,CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";
import ReactInputMask from 'react-input-mask';
import * as moment from 'moment';

const modeloDatos = {
    prestamoID: 0,
    nombre:"",
    fecha: new Date,
    primerPago: new Date,
    cuotas: 0,
    tipoPrestamo: 1,
    montoCuotas:0.00,
    montoPrestamos:0.00,
    estatus: 0
}
const modeloDatosLineas = {
    prestamoLineaID: 0,
    PrestamoID:0,
    cuotaNum: 0,
    montoCuota: 0.00,
    restante: 0.00,
    fechaCuota: new Date,
    fechaPago: new Date,
    descripcionFecha: "",
    pago: ""
}

const Version = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [tablaLineas, setTablaLineas] = useState(modeloDatosLineas);
    const [Listado, SetListado] = useState([]);
    const [ListadoLinea, SetListadoLinea] = useState([]);
    const [Listado1, SetListado1] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [verMovil, setverMovil] = useState(false);
    const [busqueda, setbusqueda] = useState();
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))

    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }
    let correo = JSON.parse(user).correo;

    const onChangeb = async (e) => {
        var l = Listado1;
        setbusqueda(e.target.value);
        console.log(e);
        var searchData = l.filter((item) => {
            if (
              (  item.telefono + item.nombre )
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            } 
        });
        SetListado(searchData);
    };

    const obtenerDatos = async () => {
        let response = await fetch(Api + "Transporte/ListaPrestamos" );
        if (response.ok) {
            let data = await response.json()
            SetListado1(data)
            if( pendiente){
                SetListado  (data)
            }
            setPendiente(false)
       
           
           
        }
    }
    const obtenerDatosLineas = async (x) => {
        let response = await fetch(Api + "Transporte/ListaPrestamosLineas/"+x );
        if (response.ok) {
            let data = await response.json()
            SetListadoLinea(data)           
        }
    }
    const Pagado = async (x) => {
        let response = await fetch(Api + "Transporte/ListaPrestamosLineas/"+x );
        if (response.ok) {
            let data = await response.json()
            SetListadoLinea(data)           
        }
    }

    const GenerarCuota = async (e) => {
        let response = await fetch(Api + "Transporte/GenerarCuota/" +e);
        if (response.ok) {
            let data = await response.json()
            SetListadoLinea(data)  
           
           
        }
    }

    useEffect(() => {
        obtenerDatos();
    },[])


    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        if (tabla.prestamoID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Transporte/GuardarPrestamos", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
     
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Transporte/EditarPrestamos", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
           
            let data = await response.json()

            GenerarCuota(data.prestamoID)
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModalMovil = (data) => {
        setTabla(data);
     
        setverMovil(!verMovil);
    }
    const abrirEditarModal = (data) => {
        setTabla(data);
        obtenerDatosLineas(data.prestamoID)
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
        setverMovil(false)
    }

    

    const columns = [
        {
            name: 'Fecha',
            selector: row => (<>
                {<a onClick={() => abrirEditarModalMovil(row)}> {moment(row.fecha).format("DD/MM/YYYY")}</a>}
               
            </>),
            sortable: true,
        },
        {
            name: 'Nombre ',
            selector: row => row.nombre,
            sortable: true,
        },
       
      
             {
            name: 'Monto Cuota',
                 selector: row => row.montoCuotas,
            sortable: true,
        },     {
            name: 'Monto',
                 selector: row => row.montoPrestamos,
            sortable: true,
        },
        {
            name: 'Estatus',
            selector: row => row.id,
            sortable: true,
        },
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
                  

                </>
            ),
        },
    ];
    const columnsLineas = [
        {
            name: 'Cuota',
            selector: row => row.cuotaNum,
            sortable: true,
        },
        {
            name: 'Dia ',
            selector: row => "Sabado",
            sortable: true,
        },
       
      
             {
            name: 'Fecha',
                 selector: row => row.descripcionFecha,
            sortable: true,
        },     {
                 name: 'Pago',
                 selector: row => row.montoCuota,
            sortable: true,
        },
        {
            name: 'X',
            selector: row => row.pago,
            sortable: true,
        },   {
            name: 'Restante',
            selector: row => row.restante,
            sortable: true,
        },
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
                  

                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de prestamos
                </CardHeader>
                <CardBody>
                 <Row>  
                    <Col md="8">
                    <Input type="search" name="busqueda" onChange={(e) => onChangeb(e)} placeholder="Busqueda por telefono / nombre " ></Input>
                        </Col>
                        <Col md="4">     <Button color="success" size="sm"
                        onClick={() => setVerModal(!verModal)}
                    >Nuevo Prestamo</Button></Col></Row> 
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal} className="modal-preguntas">
                <ModalHeader className=" modal-header1">
                    Mantenimiento de Cliente
                </ModalHeader>
                <ModalBody>
                    <Row>

                       
                        <Col md="6">
                    <FormGroup>
                      
                                <Label>Nombre </Label>
                                <Input bsSize="sm" name="nombre" onChange={handleChange} value={tabla.nombre} />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                    <FormGroup>
                              
                                <Label>Primer Pago </Label>
                                <Input type="date" bsSize="sm" name="primerPago" onChange={handleChange} value={moment(tabla.primerPago).format("dd/mm/yyyy")} />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Monto</Label>
                                <Input bsSize="sm" name="montoPrestamos" onChange={handleChange} value={tabla.montoPrestamos} />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Cantidad </Label>
                                <Input bsSize="sm" name="cuotas" onChange={handleChange} value={tabla.cuotas} />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Pagos</Label>
                                <Input bsSize="sm" name="montoCuotas" onChange={handleChange} value={tabla.montoCuotas} />
                            </FormGroup>
                        </Col>
                        <br>
                        </br>
                        <DataTable
                            columns={columnsLineas}
                            data={ListadoLinea}
                            progressPending={pendiente}
                            customStyles={customStyles}
                        />
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                      //   onClick={GenerarCuota}
                       onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

          



        </>
    )

}
export default Version;